import styled, { css } from "styled-components";

export const Highlight = styled.span`
  ${({ theme }) => css`
    color: ${theme.fontColor.DEFAULT};
    font-weight: ${theme.fontWeight.MEDIUM};
    background-color: ${theme.searchHighlightColor};
  `}
`;
